import React, { useEffect, useState } from "react";
import classes from "./CheckYourEmail.module.css";
import { Row, Col, Container } from "react-bootstrap";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { MobileHeader } from "../../stories/MobileHeader/MobileHeader";
import {
  ArrowUpRightBlue,
  BackwardArrow,
  logo,
  studentSignupCover,
} from "../../constant/imagePath";
import { useHistory, useLocation } from "react-router-dom";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { apiHeader, BaseURL } from "../../Config/apiUrl";
import { Post } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";

export default function CheckYourEmail() {
  const history = useHistory();
  const location = useLocation();
  const email = location.state || "lytesnap@gmail.com";
  const [isMobile, setIsMobile] = useState(false);

  const [loading, setLoading] = useState(false);
  const sendEmailApiUrl = BaseURL('auth/emailVerification');


  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  // useEffect(() => {
  //   HandleSubmitSendMail();
  // }, []);

  const HandleSubmitSendMail = async() => {
    setLoading(true);
    const Header = await apiHeader(false);
    const data = {
      "email": email
    };

    const response = await Post(sendEmailApiUrl, data, Header);
    setLoading(false);
    if (response !== undefined) {
      toast.success(`Email verification link has been send successfully, check your inbox.`);
      // toast.success(`Please check your email to verify your account.`);
    }
  }
  return (
    <>
      <style jsx>{`
        .${classes.mainHeading} {
          font-size: ${isMobile ? "26px" : Fonts.h3.fontSize};
          line-height: ${isMobile ? "32px" : Fonts.h3.lineHeight};
          font-family: ${isMobile ? Fonts.h2.fontFamily : Fonts.h3.fontFamily};
          color: ${Colors.neutralShadesOfNero};
        }
      `}</style>
      <div>
        <Container fluid className={classes.container}>
          <Row>
            {isMobile ? (
              <MobileHeader
                isLogo={true}
                isAvatar={false}
                customStyle={{ padding: "16px 0px 0px 16px " }}
              />
            ) : (
              <BeforeLoginHeader
                onClick={() => {
                  history.push({
                    pathname: "welcome",
                  });
                }}
                icon={logo}
                text1={"Don’t have an account?"}
                text2={"Get started"}
                goBackOnClick={() => history.goBack()}
              />
            )}

            <Col
              md={6}
              className={`p-0  ${[
                classes.imageContainer,
                classes.innerContainer,
              ].join(" ")}`}
            >
              <img
                className="img-fluid d-block w-100 hvh-100"
                src={studentSignupCover}
              />
            </Col>
            <Col
              md={6}
              className={`
              // p-5
                ${[classes.innerContainer, classes.rightContainer].join(" ")}`}
            >
              <div className={classes.goBack}>
                <LinkButtonWithIcon
                  leftIcon={BackwardArrow}
                  text={"Go back"}
                  iconStyle={{ marginRight: "16px" }}
                />
              </div>

              <div className={classes.mainContent}>
                <h3 className={classes.mainHeading}>Check your email</h3>
                <p style={{ ...Fonts.p1, color: Colors.suvaGrey }}>
                  To confirm your email address, follow the link in the Email we
                  sent to{" "}
                  <a style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
                    {email}
                  </a>
                </p>
                <LinkButtonWithIcon
                  text={"Resend Email"}
                  rightIcon={ArrowUpRightBlue}
                  primary={true}
                  iconStyle={{ marginLeft: "0px" }}
                  disabled={loading}
                  onClick={()=>{
                    loading == false && HandleSubmitSendMail();
                  }}
                />
              </div>
              {/* Already have account Login for mobile  */}
              <div className={classes.alreadyHaveAccountForMobile}>
                <p
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  Already have an account?
                </p>
                <LinkButtonWithIcon
                  primary={true}
                  text={"Log in"}
                  rightIcon={ArrowUpRightBlue}
                  iconStyle={{ margin: "0px" }}
                  onClick={() => history.push("/login")}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
